import { Component, Input, OnInit, TemplateRef } from "@angular/core";
import {
  ReportDesignerItemTab,
  ReportDesignerItemTabItem
} from "../../report-design-item";

@Component({
  selector: "snt-report-form-renderer-tab",
  templateUrl: "report-form-renderer-tab.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportFormRendererTabComponent implements OnInit {
  @Input()
  item!: ReportDesignerItemTab;

  @Input()
  templateOutlet!: TemplateRef<any>;

  @Input()
  level!: number;

  @Input()
  readOnly: boolean = false;

  tabsDataSource:
    | Array<{
        html: string;
        item: ReportDesignerItemTabItem | null;
        attachments?: boolean;
      }>
    | undefined;

  selectedIndex = 0;

  ngOnInit(): void {
    this.tabsDataSource = [
      ...this.item.config.tabs.map((tab) => ({
        html: tab.name,
        item: tab,
        items: tab.items
      }))
    ];
  }

  async renderPdfObject(): Promise<Record<string, any>> {
    return {
      type: "tab",
      config: {}
    };
  }
}
